export const AVAILABLE_TYPES = {
  json: "application/json",
  jsonld: "application/ld+json",
} as const;

export type AvailableTypes = typeof AVAILABLE_TYPES;

export const DEFAULT_TYPE = "json" satisfies keyof AvailableTypes;

export type DefaultType = typeof DEFAULT_TYPE;

interface ApiViolation {
  propertyPath: string;
  type: string;
  title: string;
}

export interface ApiError {
  detail?: string;
  status?: number;
  code?: number;
  title?: string;
  type?: string;
  message?: string;
  violations?: ApiViolation[];
}
